module.exports = __webpack_public_path__ + "img/doener-1.9d48af58.jpg";